import React, {Component} from 'react'
import propTypes from 'prop-types'
import Resizable from 'components/resizable'
import {prefix} from 'helpers/component'

export const HeaderHeight = 30

const getClassName = prefix('pivotTable-groupHeader-')

class GroupHeader extends Component {
    doSize = (newPos, oldPos) => {
        const { size, onSize } = this.props
        const curSize = size
        const newSize = curSize - oldPos.width + newPos.width
        onSize(newSize)
    }

    render() {
        const {
            label,
            size,
            align,
            canSize = true,
            isDragPreview,
            isDragPlaceholder,
        } = this.props

        let style = {textAlign: align || 'left'}
        if (isDragPreview) style = {...style, width: size}

        const classes = ['column']
        if (isDragPreview)
            classes.push('column-drag-preview')

        if (isDragPlaceholder) {
            classes.push('column-drag-placeholder')
            return <span className={getClassName(classes)} style={style}/>
        }

        const content = (
            <span className={getClassName(classes)} style={style} onMouseDown={this.mouseDown}>
        {label}
      </span>
        )

        if (canSize) return <Resizable handles={{right: true}} handleSize={20} onSize={this.doSize}
                                       height={HeaderHeight}>{content}</Resizable>
        return content
    }
}

GroupHeader.propTypes = {
    label: propTypes.oneOfType([
        propTypes.string,
        propTypes.number,
        propTypes.object,
    ]).isRequired,
    size: propTypes.oneOfType([
        propTypes.number,
        propTypes.string,
    ]),
    align: propTypes.string,
    canSize: propTypes.bool,
    onSize: propTypes.func,
    isDragPreview: propTypes.bool,
    isDragPlaceholder: propTypes.bool,
}

export default GroupHeader
